import { useAuth } from "@healthos/auth/react";
import { User } from "@phosphor-icons/react";
import { useState } from "react";
import { Link } from "react-router-dom";
import { readContactCentreAccount } from "./contact-centre-account";
import { ContactCentreSettingsModal } from "./contact-centre-settings-modal";

type Props = {
  companionExit: boolean;
  userId: string | null;
};

export function ContactCentreChrome({ companionExit, userId }: Props) {
  const { state } = useAuth();
  const [settingsOpen, setSettingsOpen] = useState(false);
  const profile = state.status === "signedIn" ? state.user.profile : undefined;
  const account = readContactCentreAccount({
    userId,
    email: profile?.email,
  });

  return (
    <>
      <div className="absolute right-5 top-5 z-30 flex items-center gap-2">
        {companionExit ? <CompanionExit /> : null}
        <button
          type="button"
          aria-label="Open settings"
          onClick={() => setSettingsOpen(true)}
          className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-navy/10 bg-surface-ambient/80 text-ink-primary backdrop-blur-sm transition-transform duration-200 hover:scale-[1.04] active:scale-[0.96] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-500"
        >
          <User size={20} weight="regular" aria-hidden="true" />
        </button>
      </div>
      <ContactCentreSettingsModal
        open={settingsOpen}
        onOpenChange={setSettingsOpen}
        userId={account.userId}
        email={account.email}
      />
    </>
  );
}

function CompanionExit() {
  return (
    <Link
      to="/today"
      className="inline-flex min-h-11 items-center rounded-full border border-navy/10 bg-surface-ambient/80 px-4 font-mono text-xs font-semibold uppercase tracking-[0.16em] text-ink-primary backdrop-blur-sm transition-transform duration-200 hover:scale-[1.04] active:scale-[0.96] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-500"
    >
      Companion
    </Link>
  );
}
